module.exports = __webpack_public_path__ + "img/48.78ff84ef.jpg";